import { axiosInstance } from "api/axios.instance"
import type { TCreateNoteRequest, TNote, TUpdateNoteRequest } from "types/elevationReferences.type"

// REQ-395/396: note (free-text annotation) create/edit/delete. Kept separate from
// `AnnotationService` (rendering-only) and from `quotations.service` — notes have their own small
// endpoint surface, so they get their own file per the service → hook → component convention in
// AGENTS.md, mirroring how `highlights.service.ts` was split off for the sibling REQ-400 feature.
class NotesService {
	static QUOTATIONS = "quotations"
	static NOTES = "notes"

	async createNote(quotationId: number, body: TCreateNoteRequest) {
		return axiosInstance.post<TNote>(`${NotesService.QUOTATIONS}/${quotationId}/${NotesService.NOTES}/`, body)
	}

	async updateNote(quotationId: number, noteId: number, body: TUpdateNoteRequest) {
		return axiosInstance.patch<TNote>(
			`${NotesService.QUOTATIONS}/${quotationId}/${NotesService.NOTES}/${noteId}/`,
			body,
		)
	}

	// `version` is a required QUERY param here (not a body field) — verified via `pnpm run api:show`.
	// `204` on success, no body; a mismatch is a `400` with the note left untouched, and the caller
	// must refetch and retry.
	async deleteNote(quotationId: number, noteId: number, version: number) {
		return axiosInstance.delete(`${NotesService.QUOTATIONS}/${quotationId}/${NotesService.NOTES}/${noteId}/`, {
			params: { version },
		})
	}
}

export default new NotesService()
